import { normalizeSheetRows } from "./payloadRows";
import { readLinkedValues } from "./multiValueExport";
import { isSampleTestRow } from "./sampleDataFilter";

const readRateTypeCode = (row: Record<string, unknown>): string => {
  const values = readLinkedValues(row["Rate Type"]);
  return values[0] ?? "";
};

const dedupeRateTypeRows = (sheetData: unknown): Record<string, unknown>[] => {
  const seen = new Set<string>();
  const rows: Record<string, unknown>[] = [];

  for (const row of normalizeSheetRows(sheetData)) {
    if (isSampleTestRow(row)) {
      continue;
    }

    const code = readRateTypeCode(row);
    if (!code) {
      continue;
    }

    const key = code.toLowerCase();
    if (seen.has(key)) {
      continue;
    }

    seen.add(key);
    rows.push(row);
  }

  return rows;
};

/** One RateType row per unique rate type code. */
export const mapRateTypeExportRows = dedupeRateTypeRows;

/** Validates duplicate rate type codes before import. */
export const validateRateTypeExportDuplicates = (
  sheetData: unknown,
): string[] => {
  const seen = new Map<string, number>();
  const errors: string[] = [];
  let rowIndex = 0;

  for (const row of normalizeSheetRows(sheetData)) {
    if (isSampleTestRow(row)) {
      continue;
    }

    rowIndex += 1;
    const code = readRateTypeCode(row);
    if (!code) {
      continue;
    }

    const key = code.toLowerCase();
    const firstRow = seen.get(key);
    if (firstRow !== undefined) {
      errors.push(
        `Rate Type "${code}" is duplicated (rows ${firstRow} and ${rowIndex}). Each rate type code must be unique.`,
      );
      continue;
    }

    seen.set(key, rowIndex);
  }

  return errors;
};
